import { pickBy } from 'lodash-es';
/**
 * Process a message through a list of middlewares
 * @param middlewares - List of middlewares to apply
 * @param message - Message to process
 * @param firstEntrySlug - The thread_url_slug of the first entry of the thread
 * @returns Processed message or undefined if the message is filtered out
 */
export function processMessageWithMiddlewares(middlewares, message, firstEntrySlug) {
    return middlewares.reduce((m, middleware) => middleware(m, firstEntrySlug), message);
}
/**
 * Middleware that filters out nullish values from a message. We do this
 * because we want to preserve the existing fields of the previous message when we
 * stream a new one.
 * @param message - Message to process
 * @param firstEntrySlug - The thread_url_slug of the first entry of the thread (unused in this middleware)
 * @returns Processed message or undefined if the message is filtered out
 */
export const filterNullishValuesMiddleware = (message, _firstEntryOfThread) => {
    if (!message) {
        return message;
    }
    return pickBy(message, (v) => v != null);
};
//# sourceMappingURL=middlewares.js.map